import { AppBadge } from '@/shared/components/app-guide/AppBadge';
import type { AppOnlyFeatureKey } from '@/shared/constants/appOnlyFeatures';
import { cn } from '@/shared/lib/utils';
import { useUIStore } from '@/stores/uiStore';
import type { ReactNode } from 'react';

/**
 * M-13 A2 — 인라인 비활성 버튼 + [앱] 배지.
 * 보기에는 비활성이지만 클릭은 받아서 X6 공통 팝업을 연다.
 * (disabled 속성을 쓰면 클릭 이벤트가 막히므로 aria-disabled로 표시한다)
 */
export const AppOnlyButton = ({
  feature,
  children,
  className,
  size = 'md',
}: {
  feature: AppOnlyFeatureKey;
  children: ReactNode;
  className?: string;
  size?: 'md' | 'lg';
}) => {
  const openAppOnly = useUIStore((s) => s.openAppOnly);
  return (
    <button
      type="button"
      aria-disabled="true"
      onClick={() => openAppOnly(feature)}
      className={cn(
        'inline-flex shrink-0 items-center justify-center gap-1.5 rounded-md border border-line-disabled bg-muted px-3 font-medium whitespace-nowrap text-ink-disabled',
        size === 'md' ? 'h-[38px] text-xs' : 'h-11 text-[13px]',
        className,
      )}
    >
      {children}
      <AppBadge onWhite />
    </button>
  );
};
